export enum UmpireSquadMemberType {
  PLAYER = 'player',
  STAFF_MEMBER = 'staff_member',
}
